import { EntityListTypeName } from '@ydistri/api-sdk';
import { Popover, Tag } from 'antd';
import { COLORS } from '@ydistri/theme';
import { styled } from 'styled-components';
import { getEntityListSpecification } from '../../../screens/ProjectAdministration/EntityListAdministration/entityListsLib';
import React from 'react';
import { Row } from '@ydistri/ds';

const EntityListTypeTag = styled(Tag)`
  color: ${COLORS.GREY};
  line-height: 14pt;
`;

interface EntityListTypeBadgeProps {
  typeNames: EntityListTypeName[];
}

/**
 * Short badge component to display the type of entity list (e.g., Source, Target, MinLayer, Forced).
 * A short name is provided by EntityListSpecification subclasses.
 * @param typeName - The type name of the entity list to be displayed.
 */
const EntityListTypeBadge: React.FC<EntityListTypeBadgeProps> = ({ typeNames }) => {
  const tags = typeNames.map(typeName => {
    const spec = getEntityListSpecification(typeName);

    //zIndex needs to overlap the Select dropdown menu where this is also used
    return (
      <Popover key={spec.shortName} content={spec.title} zIndex={2000}>
        <EntityListTypeTag>{spec.shortName}</EntityListTypeTag>
      </Popover>
    );
  });

  return <Row data-type="EntityListTypeBadgeContainer">{tags}</Row>;
};

export default EntityListTypeBadge;
